import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import PrimaryButton from '../common/PrimaryButton'
import HomeEventRow from './HomeEventRow'
import { homeUpcomingEvents } from '../../data/homeContent'
import {
  HOME_MOBILE_MQ,
  homeMobilePaddingX,
  homeSectionPy,
  homeSectionTitleSx,
} from './homeMobileLayout'

export default function UpcomingEventsSection() {
  const [hoveredSlug, setHoveredSlug] = useState(null)

  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        maxWidth: 1920,
        mx: 'auto',
        px: homeMobilePaddingX,
        py: homeSectionPy,
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ maxWidth: 1520 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 3, sm: 2 },
            mb: { xs: '32px', md: '80px' },
            [HOME_MOBILE_MQ]: { mb: '32px' },
          }}
        >
          <Typography
            component="h2"
            sx={{
              ...homeSectionTitleSx,
              [HOME_MOBILE_MQ]: { fontSize: 28 },
            }}
          >
            Upcoming Events
          </Typography>
          <PrimaryButton
            to="/events"
            showArrow={false}
            sx={{
              display: { xs: 'none', sm: 'inline-flex' },
            }}
          >
            See All Events
          </PrimaryButton>
        </Box>

        <PrimaryButton
          to="/events"
          showArrow={false}
          sx={{
            display: { xs: 'inline-flex', sm: 'none' },
            mb: '32px',
            [HOME_MOBILE_MQ]: { display: 'inline-flex' },
          }}
        >
          See All Events
        </PrimaryButton>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '24px', lg: '44px' },
            [HOME_MOBILE_MQ]: { gap: '24px' },
          }}
          onMouseLeave={() => setHoveredSlug(null)}
        >
          {homeUpcomingEvents.flatMap((event, index) => {
            const items = [
              <HomeEventRow
                key={event.slug}
                {...event}
                to={`/events/${event.slug}`}
                isImageActive={hoveredSlug === event.slug}
                onRowHover={() => setHoveredSlug(event.slug)}
                dateBoxGap="8px"
                dateNumberFontSize={{ xs: 40, lg: 40 }}
                dateLabelFontSize={{ xs: 20, lg: 22 }}
                mobileRowGap="8px"
              />,
            ]
            if (index < homeUpcomingEvents.length - 1) {
              items.push(
                <Box
                  key={`${event.slug}-divider`}
                  sx={{ borderBottom: '1px solid rgba(0,0,0,0.12)' }}
                />,
              )
            }
            return items
          })}
        </Box>
      </Box>
    </Box>
  )
}
